import { c as _c } from "react/compiler-runtime";
import { Box, Flex, Text } from "@chakra-ui/react";
import { defineMessages, useIntl } from "react-intl";
import { formatTime, formatDateLabel } from "./timePickerUtils";
const messages = defineMessages({
  ariaLabel: {
    id: "timeIntervalDisplay.ariaLabel",
    defaultMessage: "Selected time interval"
  },
  startTime: {
    id: "timeIntervalDisplay.startTime",
    defaultMessage: "Start time: {time}"
  },
  endTime: {
    id: "timeIntervalDisplay.endTime",
    defaultMessage: "End time: {time}"
  },
  hourSuffix: {
    id: "timeIntervalDisplay.hourSuffix",
    defaultMessage: "HR"
  }
});
export interface TimeIntervalDisplayProps {
  startMinutes: number;
  endMinutes: number;
  dateKey: string;
}
export const TimeIntervalDisplay = t0 => {
  const $ = _c(71);
  const {
    startMinutes,
    endMinutes,
    dateKey
  } = t0;
  const intl = useIntl();
  let T0;
  let T1;
  let T2;
  let endFormatted;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== dateKey || $[1] !== endMinutes || $[2] !== intl || $[3] !== startMinutes) {
    const startFormatted = formatTime(startMinutes);
    endFormatted = formatTime(endMinutes);
    T2 = Box;
    t12 = "time-interval-display";
    t13 = "cardBg";
    t14 = "card";
    t15 = "elevated";
    t16 = "8";
    t17 = "6";
    if ($[27] !== intl) {
      t18 = intl.formatMessage(messages.ariaLabel);
      $[27] = intl;
      $[28] = t18;
    } else {
      t18 = $[28];
    }
    let t20;
    if ($[29] !== dateKey || $[30] !== intl.locale) {
      t20 = formatDateLabel(dateKey, intl.locale);
      $[29] = dateKey;
      $[30] = intl.locale;
      $[31] = t20;
    } else {
      t20 = $[31];
    }
    if ($[32] !== t20) {
      t19 = <Text data-testid="time-interval-date" fontSize="sm" fontWeight="semibold" color="textMuted">{t20}</Text>;
      $[32] = t20;
      $[33] = t19;
    } else {
      t19 = $[33];
    }
    T1 = Flex;
    t6 = "baseline";
    t7 = "3";
    t8 = "2";
    t9 = "tabular-nums";
    const t21 = intl.formatMessage(messages.startTime, {
      time: startFormatted
    });
    if ($[34] !== startFormatted || $[35] !== t21) {
      t10 = <Text data-testid="time-interval-start" fontSize="3xl" fontWeight="extrabold" color="mobilysisGreen" aria-label={t21}>{startFormatted}</Text>;
      $[34] = startFormatted;
      $[35] = t21;
      $[36] = t10;
    } else {
      t10 = $[36];
    }
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <Text data-testid="time-interval-separator" fontSize="2xl" fontWeight="bold" color="mobilysisGreen">–</Text>;
      $[37] = t11;
    } else {
      t11 = $[37];
    }
    T0 = Text;
    t1 = "time-interval-end";
    t2 = "3xl";
    t3 = "extrabold";
    t4 = "mobilysisGreen";
    t5 = intl.formatMessage(messages.endTime, {
      time: endFormatted
    });
    $[0] = dateKey;
    $[1] = endMinutes;
    $[2] = intl;
    $[3] = startMinutes;
    $[4] = T0;
    $[5] = T1;
    $[6] = T2;
    $[7] = endFormatted;
    $[8] = t1;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t13;
    $[13] = t14;
    $[14] = t15;
    $[15] = t16;
    $[16] = t17;
    $[17] = t18;
    $[18] = t19;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[4];
    T1 = $[5];
    T2 = $[6];
    endFormatted = $[7];
    t1 = $[8];
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t13 = $[12];
    t14 = $[13];
    t15 = $[14];
    t16 = $[15];
    t17 = $[16];
    t18 = $[17];
    t19 = $[18];
    t2 = $[19];
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t20;
  if ($[38] !== T0 || $[39] !== endFormatted || $[40] !== t1 || $[41] !== t2 || $[42] !== t3 || $[43] !== t4 || $[44] !== t5) {
    t20 = <T0 data-testid={t1} fontSize={t2} fontWeight={t3} color={t4} aria-label={t5}>{endFormatted}</T0>;
    $[38] = T0;
    $[39] = endFormatted;
    $[40] = t1;
    $[41] = t2;
    $[42] = t3;
    $[43] = t4;
    $[44] = t5;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== intl) {
    t21 = intl.formatMessage(messages.hourSuffix);
    $[46] = intl;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t21) {
    t22 = <Text data-testid="time-interval-suffix" fontSize="sm" fontWeight="bold" color="mobilysisGreen" alignSelf="flex-start" mt="1">{t21}</Text>;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== T1 || $[51] !== t10 || $[52] !== t11 || $[53] !== t20 || $[54] !== t22 || $[55] !== t6 || $[56] !== t7 || $[57] !== t8 || $[58] !== t9) {
    t23 = <T1 align={t6} mt={t7} gap={t8} fontVariantNumeric={t9}>{t10}{t11}{t20}{t22}</T1>;
    $[50] = T1;
    $[51] = t10;
    $[52] = t11;
    $[53] = t20;
    $[54] = t22;
    $[55] = t6;
    $[56] = t7;
    $[57] = t8;
    $[58] = t9;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  if ($[60] !== T2 || $[61] !== t12 || $[62] !== t13 || $[63] !== t14 || $[64] !== t15 || $[65] !== t16 || $[66] !== t17 || $[67] !== t18 || $[68] !== t19 || $[69] !== t23) {
    t24 = <T2 data-testid={t12} bg={t13} borderRadius={t14} boxShadow={t15} px={t16} py={t17} aria-label={t18}>{t19}{t23}</T2>;
    $[60] = T2;
    $[61] = t12;
    $[62] = t13;
    $[63] = t14;
    $[64] = t15;
    $[65] = t16;
    $[66] = t17;
    $[67] = t18;
    $[68] = t19;
    $[69] = t23;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  return t24;
};